import { PortalTelemetryScreen } from '../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { Box, Paper, Grid, Typography } from "@mui/material";
import { AppPathEnum } from "../../app/enums/appPathEnum";
import MediaCard from "../request/MediaCard";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useEffect } from "react";

export default function DonationDashboard() {
    const appInsights = useAppInsightsContext();

    useEffect(() => {
        appInsights.trackEvent({ name: "Donation - Donation dashboard - on load" });
    }, []);

    const donationSpas = [
        {
            title: 'All Donations', description: 'Please select if you wish to donate to the Royal College of Surgeons in Ireland.',
            url: AppPathEnum.DONATION_IRELAND
        },
        {
            title: 'USA Only', description: 'Please select if you wish to donate to the Friends of the Royal College of Surgeons in Ireland, Inc.',
            url: AppPathEnum.DONATION_USA
        },
        {
            title: 'UK Only', description: 'Please select if you wish to donate to the Friends of RCSI.',
            url: AppPathEnum.DONATION_UK
        }
    ];

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.DonationDashboard), undefined, true);

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ ml: '1.75%', mt: '0%' }}>

                <Grid size={{ xs: 12 }}></Grid>
                
                <Grid size={{ xs: 12 }}>
                    <Typography variant='h4'>Donations</Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1'>
                        Depending on where you live, please select one of the below options
                        to access our secure online donation form.
                    </Typography>
                </Grid>

                {donationSpas.map((item) => (
                    <Grid size={{ xs: 12, md: 6, lg: 4 }} key={item.title}>
                        <MediaCard title={item.title}
                            description={item.description}
                            redirectUrl={item.url} />
                    </Grid>
                ))}

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}
